import RoxLogger from '../lib/RoxLogger'

export default class FlagsSetter {
  flagRepo
  experimentsRepo
  constructor(flagRepo, experimentsRepo) {
    this.flagRepo = flagRepo
    this.experimentsRepo = experimentsRepo
  }

  prepareFlagsWithExperiments() {
    const experiments = this.experimentsRepo.experiments || []
    RoxLogger.debug(`Set experiments ${JSON.stringify(experiments)}`)

    const flagsWithCondition = []
    experiments.forEach((experiment) => {
      if (!experiment) {
        return
      }

      experiment.flags.forEach((flag) => {
        if (!flag) {
          return
        }

        const flagObject = this.flagRepo.flagWithName(flag.name)
        if (flagObject) {
          flagsWithCondition.push(flagObject)
          this.connectExperimentToFlag(
            flagObject,
            experiment.deploymentConfiguration.condition
          )
        }
      })
    })

    this.flagRepo.flags.forEach((flagToSet) => {
      if (!flagsWithCondition.some((f) => f === flagToSet)) {
        this.connectExperimentToFlag(flagToSet, undefined)
      }
    })
  }

  setAddedFlag(addedFlag) {
    const experiment = this.experimentsRepo.experimentForFlag(addedFlag)
    if (experiment) {
      this.connectExperimentToFlag(
        addedFlag,
        experiment.deploymentConfiguration.condition
      )
    }
  }

  connectExperimentToFlag(flag, condition) {
    flag.condition = condition
  }
}
